<template>
  <div id="app" :style="colourBinding">
    <div :class="routerWrapClass">
      <router-view />
    </div>
    <div v-if="$store.state.testMode && !closed" class="testModalOuter">
      <div class="testModal">
        <h1 style="color: red">TEST MODE</h1>
        <p>This app is running in test mode, please do not use to submit real leads.</p>
        <p>Data submitted will not be followed up on, and no emails will be sent. You can still go through the questions and get mock decisions for data submitted.</p>
        <div class="button Enabled" @click="closed = true">
          <h3>confirm</h3>
        </div>
      </div>
    </div>
    <img v-if="$store.state.background !== 'none'" id="background" :src="$store.state.background" />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      closed: false
    };
  },
  watch: {
    $route() {
      document.title = "Instant Invoice Finance Offer";
    }
  },
  computed: {
    routerWrapClass: function() {
      if (this.$store.state.mode === "iframe") {
        return "routerWrapIframe";
      }
      return "routerWrapStandAlone";
    },
    colourBinding: function() {
      return {
        "--base-colour": this.$store.state.userData.app_base_colour__c,
        "--hover-colour": this.$store.state.userData.app_highlight_colour__c
      };
    }
  },
  mounted: function() {
    this.axios
      .get(window.location.href + "/settings")
      .then(res => {
        let settings = res.data;
        this.$store.state.introducerId = settings.introducerId;

        let bg = settings.background;
        if (!bg || bg.length < 4) {
          this.$store.state.background = "common/backgrounds/default.jpg";
        } else {
          this.$store.state.background = bg;
        }
        this.$store.state.logo = settings.logo || null;
        if (settings.mode === "introducer") {
          this.$store.state.quotationOnly = true;
          this.$store.state.clientMode = false;
        } else {
          this.$store.state.quotationOnly = false;
          this.$store.state.clientMode = true;
        }

        this.$store.state.mode = settings.mode;

        this.$store.state.userData = settings.acc;

        this.$store.state.testMode = settings.test;
        if (settings.test) {
          this.$store.state.quotationOnly = true;
        }
        this.$store.state.hidePrice = settings.hidePrice
        // eslint-disable-next-line no-console
        // console.log(settings)
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error);
        this.error = error;
      });
  }
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body,
#app {
  height: 100%;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
  color: #232422;
}
h1,
h2,
h3 {
  font-weight: 200;
}
a {
  color: blue;
  cursor: pointer;
}
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed");
#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: auto;
  overflow-x: hidden;
}
.routerWrapStandAlone {
  height: 100%;
  width: 100%;
  @media (min-width: 1200px) {
    max-width: 1000px;
  }
  margin: auto;
  background-color: rgba(210, 210, 210, 0.75);
}
.routerWrapIframe {
  height: 100%;
  width: 100%;
  margin: auto;
}
#background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  z-index: -1;
  object-fit: cover;
}

input {
  height: 2em;
  background-color: none;
  outline: none;
  border: none;
  text-align: center;
  font-size: larger;
}
select {
  height: 2em;
  background-color: rgba(255, 255, 255, 0.8);
  outline: none;
  //border: none;
  padding-left: 0.5em;
  text-align: center;
  text-align-last: center;
  font-size: larger;
  text-overflow: ellipsis;
  overflow: hidden;
  @media (max-width: 450px) {
    margin-left: -0.5em;
  }
}
.testModalOuter {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(194, 194, 194, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.testModal {
  min-width: 60%;
  min-height: 60%;
  max-width: 700px;
  border-radius: 0.3em;
  border: solid black 1px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 2em;
}
</style>
